<template>
    <div>
        <v-card flat>
            <v-card-text class="pt-0">
                <fieldset class="srs_fset">
                    <v-form ref="form" class="form">
                        <v-card flat :loading="loading">
                            <v-card-text>

                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                            v-if="practice.en"
                                            v-model="practice.en.name"
                                            @focus="focusValidate"
                                            hide-details="auto"
                                            outlined dense
                                            persistent-hint
                                            :rules="nameRules"
                                            :hint="$t('page.practice.create_dialog.label_en') + ' (' + $t('dashboard.menu.eventDetails.mandatory') + ')'"
                                            :label="$t('page.practice.create_dialog.label_en')"
                                            ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field v-if="practice.fr" v-model="practice.fr.name" hide-details="auto" outlined dense
                                            @focus="focusValidate"
                                            persistent-hint
                                            :hint="$t('page.practice.create_dialog.label_fr')"
                                            :label="$t('page.practice.create_dialog.label_fr')"
                                            ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field v-if="practice.es" v-model="practice.es.name" hide-details="auto" outlined dense
                                            @focus="focusValidate"
                                            persistent-hint
                                            :hint="$t('page.practice.create_dialog.label_es')"
                                            :label="$t('page.practice.create_dialog.label_es')"
                                            ></v-text-field>
                                    </v-col>
                                </v-row>

                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="darken-1" dark small @click="validate()">{{
                                    $t('common.form.save') }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </fieldset>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        practiceDetails: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            loading: false,
            practice: {
                en: {},
                fr: {},
                es: {}
            },
        }
    },
    computed: {
        nameRules() {
            let isValid = false;

            if(this.practice.en.name && this.practice.en.name.trim().length > 0) isValid = true;
            if(this.practice.fr.name && this.practice.fr.name.trim().length > 0) isValid = true;
            if(this.practice.es.name && this.practice.es.name.trim().length > 0) isValid = true;

            if(isValid) {
                this.$refs.form.resetValidation();
            }

            return [() => !!isValid || `${this.$t('page.practice.create_dialog.only_one_name_is_required')} (${this.$t('dashboard.menu.eventDetails.mandatory-optional')})`]
        }
    },
    watch: {
        practiceDetails() {
            this.setPractice(this.practiceDetails)
        }
    },
    mounted() {
        this.setPractice(this.practiceDetails)
    },
    methods: {
        focusValidate()
        {
            this.$refs.form.validate();
        },
        setPractice(practice) {
            this.practice = { ...practice };
        },
        close() {
            this.$emit('close')
        },
        validate() {
            const isValid = this.$refs.form.validate();
            if (isValid) {
                this.setLoadig();
                this.$emit('updatePractice', this.practice);
            }
        },
        setLoadig(status = true) {
            switch (status) {
                case true:
                    this.loading = true
                    break
                case false:
                    this.loading = false
                    break
            }
        }
    }
}
</script>